import * as THREE from 'three';
import { Mesh } from 'three';
import OctreeControls from '../controls/OctreeControls';
import { GLTFLoader } from '@blade-sxp/map/src/loaders/GLTFLoader';
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { mergeBufferGeometries } from 'three/examples/jsm/utils/BufferGeometryUtils';
import { isArray, reject, cloneDeep } from 'lodash';
import IndexDB from '../../utils/indexdb';
import store from '../store';
let stopLoadFn;
class GLTF extends THREE.Group {
    props;
    label;
    loader;
    observerTag;
    disposeStatus = false;
    constructor(data) {
        super();
        this.name = this.uuid;
        this.label = 'gltf';
        this.props = data;
        this.observerTag = false;
        this.props?.setaSyncTag?.(true);
        // store.fetchOctree = this.fetchOctree.bind(this);
        this.update(data, true);
    }
    update(data, isInit = false) {
        const { renderProps, id } = data;
        const { url, useOcTree = true, roiList = [], videoList = [], mode, onStart, onProgress, onEnd, onError, mainAngle, onComplete, } = renderProps;
        if (this.disposeStatus)
            return;
        if (url !== this.props?.renderProps?.url || isInit) {
            this.props = data;
            if (this.loader) {
                this.loader?.stopLoad?.bind(this.loader)?.();
            }
            this.loader = new GLTFLoader();
            onStart && onStart();
            const num = 0;
            store.modelLoaded = false;
            this.loader.load(url, (obj) => {
                if (this.disposeStatus) {
                    this.props?.setaSyncTag?.(false);
                    onEnd && onEnd();
                    return;
                }
                if (useOcTree)
                    this.fetchOctree(url, obj);
                this._remove(this);
                const fountainPositions = [];
                if (!mode) {
                    const meshList = [];
                    const mergedMeshList = [];
                    // 把需要合并的模型分组，方便后续控制。
                    const mergedGeometrys = [
                        // {
                        //   reg: /fanwei/,
                        //   geometeryList: [],
                        //   materialList: [],
                        //   name: 'lamp',
                        // },
                        {
                            reg: /^dx((?!waiwei).)*$/,
                            needUv: true,
                            geometeryList: [],
                            materialList: [],
                            name: 'dx-mesh',
                        },
                        // {
                        //   reg: /video/,
                        //   geometeryList: [],
                        //   materialList: [],
                        //   name: 'video-mesh',
                        // },
                        // 反射材质^re(?!.*shui)
                        {
                            reg: /glow|shedeng|fanwei/,
                            geometeryList: [],
                            materialList: [],
                            name: 'reflect-mesh',
                        },
                        // 双面材质
                        {
                            reg: /^ds/,
                            geometeryList: [],
                            materialList: [],
                            name: 'ds-mesh',
                        },
                        {
                            reg: /shui/,
                            geometeryList: [],
                            materialList: [],
                            name: 'water-mesh',
                        },
                        // // 夜间地面灯效
                        // {
                        //   reg: /glow/,
                        //   geometeryList: [],
                        //   materialList: [],
                        //   name: 'glow-mesh',
                        // },
                        // {
                        //   reg: /shedeng/,
                        //   needUv: true,
                        //   geometeryList: [],
                        //   materialList: [],
                        //   name: 'sd-mesh',
                        // },
                        {
                            name: 'uv',
                            geometeryList: [],
                            materialList: [],
                        },
                        {
                            name: 'uv2',
                            geometeryList: [],
                            materialList: [],
                        },
                        {
                            name: 'no-uv',
                            geometeryList: [],
                            materialList: [],
                        },
                    ];
                    obj.scene.updateWorldMatrix(true, true);
                    obj.scene?.traverse((mesh) => {
                        // 喷泉命名 PQ1-Zhongxin001、PQ1-Gao001、PQ1-Di001; PQ1指定哪一个喷泉，其他分别是中心点、喷泉的高低
                        if (mesh.name.toLowerCase().startsWith('pq')) {
                            fountainPositions.push({ position: mesh.getWorldPosition(new THREE.Vector3()), name: mesh.name });
                        }
                        if (mesh instanceof THREE.Mesh) {
                            // 转换精髓
                            const geometry = mesh.geometry.clone().applyMatrix4(mesh.matrixWorld);
                            // 虚拟体单独处理
                            if (/^UCX/.test(mesh.name) || /^VIDEO/.test(mesh.name)) {
                                const collisionMesh = new Mesh(geometry, mesh.material);
                                collisionMesh.name = mesh.name;
                                collisionMesh.matrixWorld = mesh.matrixWorld;
                                meshList.push(collisionMesh);
                                return;
                            }
                            // 有特殊命名的单独合成一个mesh
                            const item = mergedGeometrys.find((e) => e.reg?.test(mesh.name.toLowerCase()) && (e.needUv ? mesh.geometry.attributes?.uv : true));
                            if (item) {
                                item.geometeryList.push(geometry);
                                item.materialList.push(mesh.material);
                                return;
                            }
                            // 默认的合成3个mesh
                            if (!mesh.geometry.attributes.uv) {
                                mergedGeometrys.some((e) => {
                                    if (e.name === 'no-uv') {
                                        e.geometeryList.push(geometry);
                                        e.materialList.push(mesh.material);
                                    }
                                });
                            }
                            else if (!mesh.geometry.attributes.uv2) {
                                mergedGeometrys.some((e) => {
                                    if (e.name === 'uv') {
                                        e.geometeryList.push(geometry);
                                        e.materialList.push(mesh.material);
                                    }
                                });
                            }
                            else {
                                mergedGeometrys.some((e) => {
                                    if (e.name === 'uv2') {
                                        e.geometeryList.push(geometry);
                                        e.materialList.push(mesh.material);
                                    }
                                });
                            }
                            // if (mesh.geometry.attributes.uv && !mesh.geometry.attributes.uv2) {
                            //   geometeryList.push(geometry);
                            //   materialList.push(mesh.material);
                            // } else {
                            //   const normalMesh = new Mesh(geometry, mesh.material);
                            //   normalMesh.matrixWorld = mesh.matrixWorld;
                            //   normalMesh.castShadow = true;
                            //   normalMesh.receiveShadow = true;
                            //   meshList.push(normalMesh);
                            // }
                        }
                    });
                    mergedGeometrys.forEach((e, i) => {
                        if (!e.geometeryList.length)
                            return;
                        const merged = mergeBufferGeometries(e.geometeryList, true);
                        const mergedMesh = new THREE.Mesh(merged, e.materialList);
                        mergedMesh.castShadow = true;
                        mergedMesh.receiveShadow = true;
                        mergedMeshList[i] = mergedMesh;
                        mergedMesh.name = e.name || 'mergedMesh';
                        if (/glow-mesh|reflect-mesh/.test(mergedMesh.name)) {
                            mergedMesh.visible = false;
                            mergedMesh.renderOrder = -1;
                            mergedMesh.castShadow = false;
                            mergedMesh.receiveShadow = false;
                        }
                        if (e.name === 'water-mesh') {
                            mergedMesh.castShadow = false;
                            mergedMesh.receiveShadow = false;
                        }
                        if (e.name === 'ds-mesh') {
                            mergedMesh.material.forEach((mat) => {
                                mat.side = THREE.DoubleSide;
                            });
                        }
                        if (/^uv|no-uv/.test(e.name || ''))
                            mergedMesh.name = 'mergedMesh';
                        meshList.push(mergedMesh);
                    });
                    this.add(...meshList);
                    store.emit('pq', fountainPositions);
                    store.initVideo();
                }
                else {
                    obj.scene?.traverse((mesh) => {
                        if (mesh instanceof Mesh) {
                            mesh.castShadow = true;
                            mesh.receiveShadow = true;
                            // if (/fanwei/.test(mesh.name.toLowerCase())) {
                            //   // 夜间范围灯关闭
                            //   // (mesh.material as THREE.MeshBasicMaterial).transparent = true;
                            //   // (mesh.material as THREE.MeshBasicMaterial).opacity = 0;
                            //   mesh.visible = false;
                            // }
                            // if (/shedeng/.test(mesh.name.toLowerCase())) {
                            //   // 夜间范围灯关闭
                            //   mesh.visible = false;
                            // }
                            // if (/glow/.test(mesh.name.toLowerCase())) {
                            //   // 夜间范围灯关闭
                            //   mesh.visible = false;
                            // }
                            if (/glow|shedeng|fanwei/.test(mesh.name.toLowerCase())) {
                                // 夜间范围灯关闭
                                mesh.visible = false;
                                mesh.castShadow = false;
                                mesh.receiveShadow = false;
                            }
                        }
                    });
                    this.add(obj.scene);
                    this.props?.setaSyncTag?.(false);
                }
                this._init(this);
                // if (mode !== 'verticalView') {
                //   if (this.props.renderProps.mainAngle && Object.keys(this.props.renderProps.mainAngle).length > 0) {
                //     this.props?.setMainAngle(this.props.renderProps.mainAngle);
                //   } else {
                //     const mapBox = new THREE.Box3().setFromObject(obj.scene);
                //     const mainAngle = {
                //       camera: { x: 0, y: mapBox.max.y * 2, z: 0 },
                //       target: { x: 0, y: 0, z: 0 },
                //     };
                //     this.props?.setMainAngle(mainAngle);
                //   }
                // }
                this._handleMode(mode, this, this.props);
                this._handleRoiList(this.props?.renderProps?.roiList, this);
                this._handleVideoList(this.props?.renderProps?.videoList, this);
                onComplete && onComplete();
                store.modelLoaded = true;
                store.emit('init-gltf');
            }, (progress) => {
                if (progress.type === 'textureProgress') {
                    if (progress.total === progress.loaded) {
                        onEnd && onEnd();
                    }
                    else {
                        onProgress && onProgress(progress);
                    }
                }
            }, (err) => {
                if (!this.disposeStatus) {
                    onError && onError(err);
                }
                else {
                    onEnd && onEnd();
                }
            });
        }
        else {
            if (JSON.stringify(mainAngle) !== JSON.stringify(this.props.renderProps.mainAngle) && mode !== 'verticalView') {
                this.props?.setMainAngle(mainAngle);
            }
            if (mode !== this.props?.renderProps?.mode) {
                this._handleMode(mode, this, data);
                this._handleRoiList(roiList, this);
            }
            if (roiList !== this.props?.renderProps?.roiList) {
                this._handleRoiList(roiList, this);
            }
            if (videoList !== this.props?.renderProps?.videoList) {
                this._handleVideoList(videoList, this);
            }
            this.props = data;
        }
    }
    _remove(parent) {
        // 删除Group中所有元素
        parent.traverse(function (obj) {
            if (obj instanceof THREE.Mesh) {
                obj.geometry.dispose();
                obj.material.dispose();
            }
        });
    }
    async fetchOctree(url, obj) {
        const db = new IndexDB('octree');
        // eslint-disable-next-line no-useless-escape
        const octreeUrl = url.replace(/\/[^\/]*\.gltf$/, '/octree.json');
        store.loadingOctree = true;
        await new Promise((resolve, reject) => {
            db.initIndexDB(() => {
                resolve();
            });
        });
        const cache = (await db.getData(octreeUrl));
        const isEndStorage = (await db.getData(`${octreeUrl}-isEndStorage`));
        return new Promise((resolve) => {
            if (!cache?.target?.result || !isEndStorage?.target?.result?.isEndStorage) {
                fetch(octreeUrl)
                    .then((response) => {
                    return response.json();
                })
                    .then((json) => {
                    resolve(json);
                })
                    .catch((err) => reject(err));
            }
            else {
                resolve(cache.target.result.data);
            }
        })
            .then((json) => {
            const worldOctree = new OctreeControls();
            worldOctree.fromObject(json, obj.scene);
            store.worldOctree = worldOctree;
            console.log('init octree');
            if (!cache?.target?.result) {
                console.log('开始存入八叉树');
                db.setData(`${octreeUrl}-isEndStorage`, { isEndStorage: false });
                db.setData(octreeUrl, { data: json });
                db.updateData(`${octreeUrl}-isEndStorage`, { isEndStorage: true });
                db.close();
                this.observerTag = false;
                console.log('存入结束');
            }
            return json;
        })
            .finally(() => {
            store.loadingOctree = false;
            store.emit('octree-loaded', store.loadingOctree);
        });
    }
    _init(parent) {
        // init 碰撞体透明
        const billboardGroup = parent.getObjectByName('billboardGroup');
        if (billboardGroup) {
            billboardGroup.traverse((mesh) => {
                if (mesh instanceof Mesh) {
                    mesh.geometry?.dispose();
                    mesh.material?.dispose();
                }
                else {
                    if (mesh.parent) {
                        mesh?.parent.remove(mesh);
                    }
                    mesh.clear();
                }
            });
            parent.remove(billboardGroup);
        }
        parent.traverse((mesh) => {
            mesh.isObserver = false;
            if (mesh instanceof THREE.Mesh) {
                if (/^UCX/.test(mesh.name)) {
                    mesh.material = new THREE.MeshBasicMaterial();
                    mesh.material.transparent = true;
                    mesh.material.depthWrite = false;
                    mesh.material.opacity = 0;
                    mesh.onMouseDown = () => { };
                    mesh.onMouseEnter = () => { };
                    mesh.onMouseEnter = () => { };
                    mesh.onMouseLeave = () => { };
                    mesh.onMouseUp = () => { };
                }
                if (/^VIDEO/.test(mesh.name)) {
                    mesh.visible = true;
                }
            }
        });
    }
    _handleMode(mode, parent, data) {
        const { setVerticalView } = data;
        if (!mode) {
            return; // 大屏模式不做修改，定制化优化
        }
        if (mode === 'verticalView') {
            setVerticalView();
            // parent.traverse((mesh) => {
            //   (mesh as BaseMesh).isObserver = true;
            // });
        }
        else {
            if (mode === 'roiChose') {
                parent.traverse((mesh) => {
                    // TODO：需要拿到具体name规则才可以判断
                    if (mesh instanceof THREE.Mesh && /^UCX/.test(mesh.name)) {
                        mesh.material.color = new THREE.Color('rgb(0, 119, 250)').convertSRGBToLinear();
                        if (mesh.name === 'UCX_05_004_01') {
                            mesh.visible = true;
                            mesh.isObserver = true;
                        }
                        else {
                            mesh.isObserver = false;
                            mesh.visible = false;
                        }
                        mesh.material.opacity = 0.3;
                        mesh.onMouseEnter = () => {
                            document.body.style.cursor = 'pointer';
                            mesh.material.opacity = 0.8;
                        };
                        mesh.onMouseLeave = () => {
                            document.body.style.cursor = '';
                            mesh.material.opacity = 0.3;
                        };
                    }
                    else {
                        mesh.isObserver = false;
                    }
                });
            }
            else if (mode === 'mark') {
                this._init(parent);
                // parent.traverse((mesh) => {
                //   (mesh as BaseMesh).isObserver = true;
                // });
            }
            else if (mode === 'billboardChoose') {
                const billboardGroup = new THREE.Group();
                billboardGroup.name = 'billboardGroup';
                parent.traverse((mesh) => {
                    // TODO：需要拿到具体name规则才可以判断
                    if (mesh instanceof THREE.Mesh && /^VIDEO/.test(mesh.name)) {
                        const billboard = mesh.clone();
                        const baseMaterial = mesh.material.clone();
                        baseMaterial.color = new THREE.Color('rgb(0, 119, 250)').convertSRGBToLinear();
                        baseMaterial.transparent = true;
                        baseMaterial.opacity = 0.3;
                        baseMaterial.map = null;
                        billboard.material = baseMaterial;
                        billboard.isObserver = true;
                        billboard.onMouseEnter = () => {
                            document.body.style.cursor = 'pointer';
                            billboard.material.opacity = 0.8;
                            console.log('billboard.material', billboard.material.clone());
                        };
                        billboard.onMouseLeave = () => {
                            document.body.style.cursor = '';
                            billboard.material.opacity = 0.3;
                            console.log('billboard.material-1', billboard.material.clone());
                        };
                        billboardGroup?.add(billboard);
                        // mesh.visible = false;
                    }
                    else {
                        mesh.isObserver = false;
                    }
                });
                parent.add(billboardGroup);
            }
            else {
                this._init(parent);
            }
        }
    }
    // 视频贴图
    _handleVideoList(videoList, parent) {
        this.props?.renderProps?.videoList?.map((element) => {
            const mesh = parent.getObjectByName(String(element.name));
            if (mesh && mesh._map) {
                mesh.material.map = mesh._map;
            }
        });
        videoList.map((element) => {
            const mesh = parent.getObjectByName(String(element.name));
            if (mesh) {
                const cloneMap = mesh.material?.map;
                cloneMap && (mesh._map = cloneDeep(cloneMap));
                mesh.material = new THREE.MeshBasicMaterial();
                // 构造视频贴图
                const video = document.createElement('video');
                video.src = element.videoURL;
                video.autoplay = true;
                video.loop = true;
                video.muted = true;
                video.crossOrigin = 'anonymous'; // 解决视频源跨域
                video.play();
                mesh.material.map = new THREE.VideoTexture(video);
            }
        });
    }
    _handleRoiList(roiList, parent) {
        this.props?.renderProps?.roiList.map((roi) => {
            const mesh = parent.getObjectByName(String(roi.id));
            if (mesh) {
                mesh.material = new THREE.MeshBasicMaterial();
                mesh.material.transparent = true;
                mesh.material.depthWrite = false;
                mesh.isObserver = false;
                mesh.material.opacity = 0;
            }
        });
        roiList.map((roi) => {
            const mesh = parent.getObjectByName(String(roi.id));
            if (mesh) {
                mesh.material = new THREE.MeshBasicMaterial({ color: new THREE.Color('rgb(0, 119, 250)').convertSRGBToLinear() });
                mesh.material.transparent = true;
                mesh.material.depthWrite = false;
                mesh.isObserver = true;
                mesh.visible = roi.visible !== false;
                let opacity = roi.opacity;
                if (opacity === 0) {
                }
                else {
                    opacity = 0.3;
                }
                mesh.material.opacity = opacity;
                mesh.onMouseEnter = () => {
                    document.body.style.cursor = 'pointer';
                    mesh.material.opacity = 0.8;
                    if (roi.onMouseEnter && typeof roi.onMouseEnter === 'function') {
                        roi.onMouseEnter();
                    }
                };
                mesh.onClick = () => {
                    if (roi.onClick && typeof roi.onClick === 'function') {
                        roi.onClick();
                    }
                };
                mesh.onMouseLeave = () => {
                    document.body.style.cursor = '';
                    mesh.material.opacity = opacity;
                    if (roi.onMouseLeave && typeof roi.onMouseLeave === 'function') {
                        roi.onMouseLeave();
                    }
                };
                mesh.onMouseDown = () => {
                    if (roi.onMouseDown && typeof roi.onMouseDown === 'function') {
                        roi.onMouseDown();
                    }
                };
                mesh.onMouseUp = () => {
                    if (roi.onMouseUp && typeof roi.onMouseUp === 'function') {
                        roi.onMouseUp();
                    }
                };
            }
        });
    }
    dispose() {
        if (this.loader) {
            this.loader?.stopLoad?.bind(this.loader)?.();
            this.props?.setaSyncTag?.(false);
        }
        // stopLoadFn && stopLoadFn();
        // this.clearLoader();
        this.disposeStatus = true;
        const { onDestory } = this.props;
        this.traverse(function (obj) {
            if (obj instanceof THREE.Mesh) {
                obj.geometry.dispose();
                if (isArray(obj?.material)) {
                    obj?.material.map((item) => item?.dispose());
                }
                else {
                    obj?.material?.dispose();
                }
                // ((obj as Mesh).material as any).dispose();
            }
            else {
                if (obj.parent) {
                    obj?.parent.remove(obj);
                }
                obj.clear();
            }
        });
        this.parent?.remove(this);
        this.clear();
        if (onDestory && typeof onDestory === 'function') {
            onDestory(this);
        }
    }
}
export default GLTF;
